import React from 'react';
import { useSelector } from 'react-redux';
import { selectFetching } from 'src/store/selectors/configurations';
import LimitedWidthPage from 'src/components/PageWrappers/LimitedWidthPage';
import DashBoardMenu from 'src/components/app/DashBoardMenu';
import { routes } from 'src/routes/routes';
import useRoutes from 'src/routes/useRoutes';
import { makeStyles } from '@material-ui/core';
const useStyles = makeStyles(() => ({
    blur: {
        '-webkit-filter': 'blur(2px)',
        '-moz-filter': 'blur(2px)',
        '-o-filter': 'blur(2px)',
        '-ms-filter': 'blur(2px)',
        filter: 'blur(2px)'
    }
}));
function HomePage() {
    const classes = useStyles();
    const isConfigLoading = useSelector(selectFetching);
    const { getAllowedRoutes } = useRoutes();
    return (React.createElement(LimitedWidthPage, { className: isConfigLoading ? classes.blur : '' },
        React.createElement(DashBoardMenu, { routes: getAllowedRoutes(routes) })));
}
export default HomePage;
